<div class="flex gap-6 w-full" data-testid="account-panel">
  <app-settings-sidebar [activeTab]="activeTab()" (tabSelected)="onTabSelected($event)" />

  <app-content-container class="flex-1 min-w-0">
    @switch (activeTab()) {
      @case ('userManagement') {
        <app-user-management class="w-full" *hasPermissionGroups="[[EPermissions.userGroupDeleteMemberOwn]]" />
      }

      @case ('globalTemplates') {
        <app-global-templates class="w-full" *hasPermissionGroups="[[EPermissions.campaignCreate]]" />
      }
    }
  </app-content-container>
</div>
